module.exports = __webpack_public_path__ + "img/calendar-tile-bg-1.89aa4702.png";